import React from 'react'
import injectSheet from 'react-jss'
import styles from './image-dialog.styles'
import { Modal, ModalHeader, ModalContent } from 'pobble-components/dist/modal'
import ImageSelector from '../../../image-selector/image-selector.container'

const ImageDialog = ({
  classes,
  isOpen,
  onChange,
  onClose,
  onSubmit,
  title,
  updating,
  defaultSearchValue,
  onUnsplashSelect,
  pending,
  id,
  onFileSelect,
  onMainImageSelect,
  offerUseCoverImage
}) => (
  <Modal closeButton isOpen={isOpen} requestClose={onClose}>
    <ModalHeader>Set image</ModalHeader>
    <ModalContent legacy className={classes.modalContent}>
      <ImageSelector
        pending={pending}
        onUnsplashSelect={(...props) =>
          onUnsplashSelect(...props).then(onClose)
        }
        defaultSearchValue={defaultSearchValue}
        onFileSelect={(...props) => onFileSelect(...props).then(onClose)}
        onMainImageSelect={
          offerUseCoverImage
            ? (...props) => {
                onMainImageSelect(...props)
                onClose()
              }
            : undefined
        }
      />
    </ModalContent>
  </Modal>
)

export default injectSheet(styles)(ImageDialog)
